<header id="header">

    <div class="container">

        <nav class="navbar navbar-default">
            <a class="navbar-brand" [routerLink]="[ data.URL_HOME ] | localize"><img
                    src="./assets/imagens/logo_branca.png"></a>

            <ul class="navbar-nav float-right">
                <li>
                    <a [routerLink]="[ data.URL_HOME ] | localize"><i class="fa fa-home mr-2"></i>Home</a>
                </li>
            </ul>

        </nav>

        <section id="intro">
            <div class="container">
                <div class="row justify-content-center align-items-center">

                    <div class="col-lg-6 text-justify mt-3 mb-3">
                        <div *ngFor="let paragrafo of data.PARAGRAFOS">
                            <h4>{{ paragrafo.TEXTO }}</h4>
                        </div>
                    </div>

                    <div class="col-lg-5 offset-lg-1">

                        <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">

                            <div class="card">

                                <div class="card-body p-4">

                                    <div class="row text-center">
                                        <div class="col-md-12">
                                            <h2>{{ data.CADASTRO.TITULO }}</h2>
                                        </div>
                                    </div>

                                    <div class="row d-flex justify-content-center">

                                        <div class="col-md-12">

                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="control-group">
                                                        <div class="form-group mb-0 pb-2">
                                                            <label
                                                                class="control-label">{{ data.CADASTRO.CAMPO_EMPRESA }}
                                                                <span class="text-danger">*</span></label>
                                                            <input class="form-control form-control-sm" type="text"
                                                                formControlName="formEmpresa">

                                                            <!-- Mensagens de erro -->
                                                            <div
                                                                *ngFor="let validator of data.CADASTRO.VALIDATOR.EMPRESA">
                                                                <span class="text-danger"
                                                                    *ngIf="formGroup.get('formEmpresa').hasError(validator.TYPE) && (formGroup.get('formEmpresa').dirty || formGroup.get('formEmpresa').touched) ">{{ validator.MENSAGEM }}</span>
                                                            </div>
                                                            <!-- Mensagens de erro -->

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="control-group">
                                                        <div class="form-group mb-0 pb-2">
                                                            <label class="control-label">{{ data.CADASTRO.CAMPO_NOME }}
                                                                <span class="text-danger">*</span></label>
                                                            <input class="form-control form-control-sm" type="text"
                                                                formControlName="formNome">

                                                            <!-- Mensagens de erro -->
                                                            <div *ngFor="let validator of data.CADASTRO.VALIDATOR.NOME">
                                                                <span class="text-danger"
                                                                    *ngIf="formGroup.get('formNome').hasError(validator.TYPE) && (formGroup.get('formNome').dirty || formGroup.get('formNome').touched) ">{{ validator.MENSAGEM }}</span>
                                                            </div>
                                                            <!-- Mensagens de erro -->

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="control-group">
                                                        <div class="form-group mb-0 pb-2">
                                                            <label class="control-label">{{ data.CADASTRO.CAMPO_EMAIL }}
                                                                <span class="text-danger">*</span></label>
                                                            <input class="form-control form-control-sm" type="email"
                                                                formControlName="formEmail">

                                                            <!-- Mensagens de erro -->
                                                            <div
                                                                *ngFor="let validator of data.CADASTRO.VALIDATOR.EMAIL">
                                                                <span class="text-danger"
                                                                    *ngIf="formGroup.get('formEmail').hasError(validator.TYPE) && (formGroup.get('formEmail').dirty || formGroup.get('formEmail').touched) ">{{ validator.MENSAGEM }}</span>
                                                            </div>
                                                            <!-- Mensagens de erro -->

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="control-group">
                                                        <div class="form-group mb-0 pb-2">
                                                            <label
                                                                class="control-label">{{ data.CADASTRO.CAMPO_TELEFONE }}
                                                                <span class="text-danger">*</span></label>
                                                            <input class="form-control form-control-sm" type="text"
                                                                formControlName="formTelefone" maxlength="18">

                                                            <!-- mask="(99) 99999-9999" -->

                                                            <!-- Mensagens de erro -->
                                                            <div
                                                                *ngFor="let validator of data.CADASTRO.VALIDATOR.TELEFONE">
                                                                <span class="text-danger"
                                                                    *ngIf="formGroup.get('formTelefone').hasError(validator.TYPE) && (formGroup.get('formTelefone').dirty || formGroup.get('formTelefone').touched) ">{{ validator.MENSAGEM }}</span>
                                                            </div>
                                                            <!-- Mensagens de erro -->

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="control-group">
                                                        <div class="form-group mb-0 pb-2">
                                                            <label class="control-label">{{ data.CADASTRO.CAMPO_PAIS }}
                                                                <span class="text-danger">*</span></label>
                                                            <select class="form-control form-control-sm"
                                                                formControlName="formPais">
                                                                <option value="">
                                                                <option *ngFor="let country of countrys"
                                                                    value="{{country.CODIGO}}">
                                                                    {{country.TITULO}}</option>
                                                            </select>

                                                            <!-- Mensagens de erro -->
                                                            <div *ngFor="let validator of data.CADASTRO.VALIDATOR.PAIS">
                                                                <span class="text-danger"
                                                                    *ngIf="formGroup.get('formPais').hasError(validator.TYPE) && (formGroup.get('formPais').dirty || formGroup.get('formPais').touched) ">{{ validator.MENSAGEM }}</span>
                                                            </div>
                                                            <!-- Mensagens de erro -->

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="control-group">
                                                        <div class="form-group mb-0 pb-2">
                                                            <label
                                                                class="control-label">{{ data.CADASTRO.CAMPO_USUARIO }}
                                                                <span class="text-danger">*</span></label>
                                                            <input class="form-control form-control-sm" type="text"
                                                                formControlName="formUsuario">

                                                            <!-- Mensagens de erro -->
                                                            <div
                                                                *ngFor="let validator of data.CADASTRO.VALIDATOR.USUARIO">
                                                                <span class="text-danger"
                                                                    *ngIf="formGroup.get('formUsuario').hasError(validator.TYPE) && (formGroup.get('formUsuario').dirty || formGroup.get('formUsuario').touched) ">{{ validator.MENSAGEM }}</span>
                                                            </div>
                                                            <!-- Mensagens de erro -->

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mb-2">
                                                <div class="col-md-12">
                                                    <div class="control-group">
                                                        <div class="form-group mb-0 pb-2">
                                                            <label
                                                                class="control-label">{{ data.CADASTRO.CAMPO_CONHECEU }}</label>
                                                            <input class="form-control form-control-sm" type="text"
                                                                formControlName="formComoConheceu">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="control-group">
                                                        <div class="form-group mb-0">
                                                            <button class="btn" type="submit"
                                                                [disabled]="!formGroup.valid">{{ data.CADASTRO.BOTAO }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </section>

    </div>

</header>

<main>

    <section id="como-funciona">
        <div class="container text-center">
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <h2>{{ data.COMO_FUNCIONA.TITULO }}</h2>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-md-12">
                        <img class="img-fluid" src="{{ data.COMO_FUNCIONA.IMAGEM.URL }}"
                            alt="{{ data.COMO_FUNCIONA.IMAGEM.DESCRICAO }}">
                    </div>
                </div>
            </div>
        </div>

    </section>

    <section id="funcionalidades">

        <div class="container">

            <div class="row">
                <div class="col-md-12 text-center">
                    <h2>{{ data.FUNCIONALIDADES.TITULO }}</h2>
                </div>
            </div>

            <div class="row text-center d-flex justify-content-center mt-5">
                <div *ngFor="let funcionalidade of data.FUNCIONALIDADES.DADOS;" class="col-sm-6 col-md-6 col-lg-3 mt-2">
                    <div class="icon mb-4">
                        <img src="{{ funcionalidade.IMAGEM.URL }}" alt="{{ funcionalidade.IMAGEM.DESCRICAO }}" />
                        <p class="text-muted text-center mt-2">{{ funcionalidade.TITULO }}</p>
                    </div>
                </div>
            </div>

        </div>

    </section>

    <section id="vantagens">

        <div class="container">

            <div class="row">
                <div class="col-md-12 text-center">
                    <h2>{{ data.VANTAGENS.TITULO }}</h2>
                </div>
            </div>

            <div class="row d-flex justify-content-center mt-5">
                <div class="col-sm-12 col-md-3 col-lg-4">
                    <div class="align-items-top">
                        <p><b>{{ data.VANTAGENS.DESCRICAO_01.TITULO }}</b></p>
                        <p>{{ data.VANTAGENS.DESCRICAO_01.DESCRICAO }}</p>
                    </div>
                    <div class="align-items-bottom">
                        <p><b>{{ data.VANTAGENS.DESCRICAO_02.TITULO }}</b></p>
                        <p>{{ data.VANTAGENS.DESCRICAO_02.DESCRICAO }}</p>
                    </div>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-4 d-flex justify-content-center align-items-center">
                    <img class="img-fluid" src="{{ data.VANTAGENS.IMAGEM.URL }}"
                        alt="{{ data.VANTAGENS.IMAGEM.DESCRICAO }}">
                </div>

                <div class="col-sm-12 col-md-3 col-lg-4">
                    <div class="align-items-top">
                        <p><b>{{ data.VANTAGENS.DESCRICAO_03.TITULO }}</b></p>
                        <p>{{ data.VANTAGENS.DESCRICAO_03.DESCRICAO }}</p>
                    </div>
                    <div class="align-items-bottom">
                        <p><b>{{ data.VANTAGENS.DESCRICAO_04.TITULO }}</b></p>
                        <p>{{ data.VANTAGENS.DESCRICAO_04.DESCRICAO }}</p>
                    </div>
                </div>
            </div>

        </div>

    </section>

</main>

<footer>

    <div class="container">

        <div class="row text-center">
            <div class="col-md-12">
                <h4 class="text-white">
                    {{ data.FOOTER.REDE_SOCIAL.TITULO }}
                </h4>
            </div>
        </div>

        <div class="row d-flex justify-content-center text-center mt-2">

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.FOOTER.REDE_SOCIAL.FACEBOOK }}" target="_blank">
                    <i class="fab fa-facebook fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.FOOTER.REDE_SOCIAL.INSTAGRAM }}" target="_blank">
                    <i class="fab fa-instagram fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.FOOTER.REDE_SOCIAL.TWITTER }}" target="_blank">
                    <i class="fab fa-twitter fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.FOOTER.REDE_SOCIAL.LINKEDIN }}" target="_blank">
                    <i class="fab fa-linkedin fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.FOOTER.REDE_SOCIAL.YOUTUBE }}" target="_blank">
                    <i class="fab fa-youtube fa-2x text-white"></i>
                </a>
            </div>

        </div>

        <div class="row mt-5">
            <div class="col-md-12 text-center text-white">
                &copy; Copyright 2021 - <a class="text-white" href="http://www.sirius.co" target="_blank"><strong>Sirius
                        Software</strong></a>. {{ data.FOOTER.RODAPE.TITULO }}
            </div>
        </div>

    </div>

</footer>